import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=1eef6dc0&"
import script from "./Agenda.vue?vue&type=script&lang=js&"
export * from "./Agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eef6dc0')) {
      api.createRecord('1eef6dc0', component.options)
    } else {
      api.reload('1eef6dc0', component.options)
    }
    module.hot.accept("./Agenda.vue?vue&type=template&id=1eef6dc0&", function () {
      api.rerender('1eef6dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Agenda.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Agenda.vue
// module id = 347
// module chunks = 0